export default {
  inputForm: {
    loginId: null,
    password: null,
  },
  loginId: null,
  password: null,
  /**
   * テストデータをセットする
   */
  setTestUser: function () {
    // ITセンター
    this.loginId = '63322013';
    this.password = 'inmj2013';
    // ダイブセンター
    // this.loginId = '51112016';
    // this.password = 'ioke2016';
    // メンバー
    // this.loginId = '20132282';
    // this.password = '2013tboe';
  },
};
